import {ProtocolMenuTypes} from 'constants/protocolExplorerEnum';
import {compact} from 'lodash';
import {
  createDuplicateMenu,
  createFavoriteMenu,
  createOpenProtocolLocationMenu,
  getSelectedProtocolsCondition,
} from './protocolExplorerMenuBusiness';

const getMenuBuilderFunc = (type) => {
  switch (type) {
    case ProtocolMenuTypes.DUPLICATE:
      return createDuplicateMenu;
    case ProtocolMenuTypes.FAVORITE_PROTOCOL:
      return createFavoriteMenu;
    case ProtocolMenuTypes.OPEN_PROTOCOL_LOCATION:
      return createOpenProtocolLocationMenu;
    default: {
      return null;
    }
  }
};

export const generateMenu =
  (menuList = [], selectedIds = []) =>
  (dispatch) => {
    const selectedProtocolConditions = dispatch(getSelectedProtocolsCondition(selectedIds));

    const menuItems = [];

    menuList.forEach((menuType) => {
      const createMenuFunc = getMenuBuilderFunc(menuType);

      if (!createMenuFunc) return;

      const menu = dispatch(createMenuFunc(selectedProtocolConditions));

      menuItems.push(menu);
    });

    return compact(menuItems);
  };

export default generateMenu;
